/**
 * CZY TEN AGENT ZROZUMIE PROŚBĘ „AKTUALIZUJ TERAZ".
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ TA BRAMKA NIE CHRONI DANYCH — CHRONI PRAWDĘ NA EKRANIE. Portal nie ma jak zapukać do
 *  agenta: prośba jedzie w ODPOWIEDZI na jego sygnał życia, więc agent starszy niż ta wersja
 *  po prostu nie zna pola i podniesie się w swoim rytmie (raz na 30 udanych cykli). Bez tej
 *  bramki przycisk dałby się kliknąć i nie zrobił NIC — bez błędu, bez śladu, bez wyjaśnienia.
 *
 *  ⚠️ TO NIE JEST PRZYPADEK BRZEGOWY, A PIERWSZY, JAKI ZOBACZĄ. W chwili wydania tej funkcji
 *  CAŁA flota jest starsza od niej, więc „wyłączony z powodem" jest tu stanem normalnym na
 *  pierwsze pół godziny każdej maszyny, a nie rzadkim wyjątkiem.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/**
 * ⚠️ MUSI ZGADZAĆ SIĘ Z `WERSJA_Z_AKTUALIZACJA_NA_ZADANIE` W INSTANCJI. Pilnuje tego
 * `prosba-o-aktualizacje.spec.ts`, który czyta tamten plik — bo dwie kopie tej samej liczby
 * w dwóch pakietach rozjadą się przy pierwszej zmianie, a objawem będzie przycisk włączony
 * na agentach, które go nie rozumieją.
 */
export const WERSJA_Z_AKTUALIZACJA_NA_ZADANIE = '0.7.159';

/**
 * Porównanie wersji `x.y.z` po CZŁONACH LICZBOWYCH.
 *
 * ⚠️ NIE TEKSTOWO: `0.7.9` jest starsze niż `0.7.10`, a po znakach wychodzi odwrotnie. Ta sama
 * pułapka, którą opisuje `wTyle()` na ekranie agentów.
 *
 * ⚠️ WERSJA NIEZNANA LICZY SIĘ JAKO ZA STARA — agent, który nie powiedział, kim jest, nie dostaje
 * przycisku obiecującego działanie. Ten sam fail-closed co w `conajmniej()` po stronie instancji.
 */
export function umieProsbeOAktualizacje(wersja: string | null | undefined): boolean {
  if (wersja == null || wersja === '') return false;
  const a = wersja.split('.').map(Number);
  const b = WERSJA_Z_AKTUALIZACJA_NA_ZADANIE.split('.').map(Number);
  if (a.length !== 3 || a.some(Number.isNaN)) return false;
  for (let i = 0; i < 3; i += 1) {
    const r = (a[i] ?? 0) - (b[i] ?? 0);
    if (r !== 0) return r > 0;
  }
  return true;
}
